'use strict';
var WebWorkify = require('webworkify');

module.exports = function () {
    return new WebWorkify(require('../../source/worker'));
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox-gl/js/util/browser/web_worker.js
 ** module id = 867
 ** module chunks = 0
 **/